export default "__VITE_ASSET__4a56d259__"